import { useContext } from 'react'
import { SchemaContext } from './schemaContext'
import type { SchemaData } from '../schema/types'

/**
 * Returns the parsed schema, or `null` while loading. Throws if used
 * outside <SchemaProvider> — that's a programming error and shouldn't
 * silently render with stale data.
 */
export function useSchema(): SchemaData | null {
  const value = useContext(SchemaContext)
  if (value === undefined) {
    throw new Error('useSchema must be used within SchemaProvider')
  }
  return value
}

/**
 * Non-throwing variant: returns the parsed schema, `null` while loading, OR
 * `null` when there is no <SchemaProvider> above. For best-effort consumers
 * that work without the schema — e.g. `useNightModeActions`, which supplies
 * night-station ids only when the schema is available and is also mounted
 * in unit tests without a provider. Prefer {@link useSchema} where the
 * provider is a hard requirement.
 */
export function useSchemaOptional(): SchemaData | null {
  return useContext(SchemaContext) ?? null
}
